import React from 'react'
import { withPrefix } from 'gatsby'
import { useStore } from '../../../../hooks/useStore'
import { SmallHeadline } from '../../../general/headlines'
import { HalfSectionLayout } from '../../../general/layouts/half-section-layout'
import { renderRichText } from 'gatsby-source-contentful/rich-text'
import { RICH_TEXT_OPTIONS } from '../../../../utils/rich-text-config'
import RichText from '../../../general/rich-text/RichText'

const HomeLanding = ({data}) => {
    return (
        <div className='home--landing'> 

            <div className='half-content flex--center'>
                <div>
                    <img className="gwyl" src={withPrefix('/images/give-where-you-live-logo-2x.webp')} alt="" />
                    <RichText>{data.homePageLandingCopy}</RichText>
                    <img className="arrow" src={withPrefix('/images/home-arrow.svg')} alt="" />
                </div>
            </div>

            <video className="landing-video-desktop" src={data.homePageLandingVideo?.file.url} muted autoPlay loop playsInline></video>
            <video className="landing-video-mobile" src={data.homePageLandingVideoMobile?.file.url} muted autoPlay loop playsInline></video>


            <style jsx>{`
                .home--landing {
                    height: 0;
                    width: 100%;
                    padding-bottom: 49.518518518518523%;
                    position: relative;

                    padding-bottom: 45%;
                    overflow: hidden;
                }

                .landing-video-mobile {
                    display: none;
                }

                video {
                    width: 100%;
                }

                .half-content {
                    position: absolute;
                    top: 0;
                    left: 0;
                    height: 100%;
                    width: 50%;
                    text-align: center;
                    padding: 0 60px;
                }
                
                .gwyl {
                    width: 400px;
                    margin-bottom: 30px;
                }

                .arrow {
                    width: 40px;
                }

                .arrow {
                    width: 30px;
                    animation: float 3s ease-in-out infinite;
                }

                @keyframes float {
                    0% {
                        transform: translatey(0px);
                    }
                    50% {
                        transform: translatey(-5px);
                    }
                    100% {
                        transform: translatey(0px);
                    }
                }

                @media (pointer: coarse), (max-width: 769px) {
                    .home--landing {
                        height: 0;
                        padding-bottom: 200%;
                    }

                    .gwyl {
                        margin: 30px 0;
                        width: 77.5%;
                        margin-top: 10px;
                    }

                    .arrow {
                        display: none;
                    }

                    .half-content {
                        padding: 20px;
                        z-index: 1;
                        transform: rotateZ(0);
                        width: 100%;
                        top: 0;


                        height: 124vw;
                    }

                    .landing-video-mobile {
                        display: block;
                    }
                    .landing-video-desktop {
                        display: none;
                    }
                }




            `}</style>
        </div>
    )
}


export default HomeLanding